import type { NavigationTranslations } from "types/visioweb/navigation";
import type { Localizations } from "~/service/l10n";

export const translations: Localizations = {
  sv: {
    continue: "Fortsätta",
    error_title: "Vad synd!",
    info_title: "Hur kartan används",
    info_text: 
      `Sök en butik eller välj destination direkt på kartan. Välj sedan den närmaste 
      butiken som utgångspunkt och tryck på Visa rutt-knappen. Navigera dig till din 
      destination genom att bläddra genom vägbeskrivningarna.`,
    loading: "Läser in…",
    not_routable_poi: `Tyvärr kan ingen rutt hittas till destinationen!`,
    overlay_instruction: "Dubbeltryck för att interagera med kartan!",
    overlay_exit_instruction: "Dubbeltryck för att avsluta fullskärmsläge",
    overlay_enter_button: "Tryck för att öppna kartan",
    overlay_exit_button: "Avsluta fullskärm",
    route_compute: "Söker rutt...",
    route: "Rutt",
    route_option_accessible: "Tillgänglig",
    route_option_shortest: "Kortast",
    route_node_dst: "Destination",
    route_node_dst_hint: `Vart vill du åka?`,
    route_node_src: "Utgångspunkt",
    route_node_src_hint: 
      `Välj en butik, dvs nära din nuvarande plats. Sök eller välj en plats från kartan.`,
    route_node_src_showmap: "Show map",
    route_not_available: "Tyvärr blev rutten inte lyckad!",
    route_show: "Visa rutt",
    search: "Sök…",
    show_location: "Visa platsen",
  },
};

export const visio: NavigationTranslations = {
  maneuvers: {
    unknown: '<unknown>',
    goStraight: 'Gå rakt',
    turnGentleRight: 'Vänd dig försöktigt till höger',
    turnGentleLeft: 'Vänd dig försöktigt till vänster',
    turnRight: 'Vänd dig till höger',
    turnLeft: 'Vänd dig till vänster',
    turnSharpRight: 'Vänd dig skarpt till höger',
    turnSharpLeft: 'Vänd dig skarpt till vänster',
    UTurnRight: 'Gör en U-sväng till höger',
    UTurnLeft: 'Gör en U-sväng till vänster',
    start: 'Starta',
    end: 'Du har anlänt',
    goUp: 'Gå upp till våning %L',
    goDown: 'Gå ner till våning %L',
    changeModality: 'Använd transportsätt %M',
    changeLayer: 'Byt byggnad',
    waypoint: 'Stanna'
  },
  nextManeuvers: {
    unknown: '<unknown>',
    goStraight: 'gå rakt',
    turnGentleRight: 'vänd dig försöktigt till höger',
    turnGentleLeft: 'vänd dig försöktigt till vänster',
    turnRight: 'vänd dig till höger',
    turnLeft: 'vänd dig till vänster',
    turnSharpRight: 'vänd dig skarpt till höger',
    turnSharpLeft: 'vänd dig skarpt till vänster',
    UTurnRight: 'gör en U-sväng till höger',
    UTurnLeft: 'gör en U-sväng till vänster',
    start: 'starta',
    end: 'du har anlänt',
    goUp: 'gå upp till våning %L',
    goDown: 'gå ner till våning %L',
    changeModality: 'använd transportsätt %M',
    changeLayer: 'byt byggnad',
    waypoint: 'stanna'
  },
  keywords: {
    for: ' för ',
    then: ' och ',
    and: ' och ',
    near: ' nära %S',
    using: ' genom att använda ',
    stairway: 'trappan',
    escalator: 'rulltrappan',
    lift: 'hissen'
  },
  durations: {
    seconds: 'några sekunder',
    oneMinute: 'cirka en minut',
    minutes: 'ungefär %d minuter'
  }
}
